<template>
  <div class="shift-section-state" :data-testid="testId">
    <div v-if="state === 'idle' || state === 'loading'" class="shift-section-state__loading">
      <a-spin />
    </div>

    <slot v-if="state === 'ready' || state === 'empty'" />

    <div v-if="state === 'empty'" class="shift-section-state__message">
      <a-icon type="inbox" class="shift-section-state__icon" />
      <h3 class="m-0">{{ emptyTitle }}</h3>
      <p class="m-0">{{ emptyDescription }}</p>
    </div>

    <div v-if="state === 'error'" class="shift-section-state__message">
      <a-alert type="error" show-icon :message="errorTitle" :description="errorDescription" />
      <a-button type="primary" ghost @click="$emit('retry')">Retry</a-button>
    </div>
  </div>
</template>

<script>
import { Alert, Button, Icon, Spin } from 'ant-design-vue'

export default {
  components: {
    'a-alert': Alert,
    'a-button': Button,
    'a-icon': Icon,
    'a-spin': Spin
  },
  props: {
    state: {
      type: String,
      required: true,
      validator: value => ['idle', 'loading', 'ready', 'empty', 'error'].includes(value)
    },
    emptyTitle: {
      type: String,
      required: true
    },
    emptyDescription: {
      type: String,
      required: true
    },
    errorTitle: {
      type: String,
      required: true
    },
    errorDescription: {
      type: String,
      required: true
    },
    testId: {
      type: String,
      default: undefined
    },
    showContentWhenEmpty: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.shift-section-state__loading,
.shift-section-state__message {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
}

.shift-section-state__message {
  color: var(--text-color-secondary);
}

.shift-section-state__message h3 {
  color: var(--text-color);
}

.shift-section-state__message .ant-alert {
  width: 100%;
  text-align: left;
}

.shift-section-state__icon {
  color: var(--text-color-secondary);
  font-size: 32px;
}
</style>
